import { all, takeEvery, takeLatest, put, call, fork } from 'redux-saga/effects'
import { normalize } from 'normalizr'
import {apiFetch, apiPostForm} from '../../helpers/restRequest'
import { deserialize } from '../../helpers/jsonApi'

import actions from './actions'
import { journalEntryFormatSchema, journalEntryFormatsSchema } from '../schema'

const {
    JOURNAL_ENTRY_FORMATS_FETCH_REQUEST,
    JOURNAL_ENTRY_FORMATS_FETCH,
    JOURNAL_ENTRY_FORMATS_FETCH_SUCCESS,
    JOURNAL_ENTRY_FORMATS_SET_PAGINATION,
    JOURNAL_ENTRY_FORMAT_SAVE_REQUEST,
    JOURNAL_ENTRY_FORMAT_SAVING,
    JOURNAL_ENTRY_FORMAT_SET_FORM_ERRORS,
    JOURNAL_ENTRY_FORMAT_SAVE_SUCCESS,
    JOURNAL_ENTRY_FORMAT_DELETE_REQUEST,
    JOURNAL_ENTRY_FORMAT_DELETE,
    JOURNAL_ENTRY_FORMAT_DELETE_SUCCESS,
    JOURNAL_ENTRY_FORMAT_FETCH_REQUEST,
    JOURNAL_ENTRY_FORMAT_FETCH,
    JOURNAL_ENTRY_FORMAT_FETCH_SUCCESS
} = actions

export function *fetchJournalEntryFormats () {
    yield takeEvery(JOURNAL_ENTRY_FORMATS_FETCH_REQUEST, function *({ payload }) {
        yield put({ type: JOURNAL_ENTRY_FORMATS_FETCH })

        const { page, per } = payload
        const queryString = `&page=${page}&per=${per}`

        const path = `/journal_entry_formats?${queryString}`
        const data = yield call(apiFetch, path)
        const formattedData = deserialize(data)
        const normalizeData = normalize(formattedData, journalEntryFormatsSchema)
        const total = data.meta.total_pages * per

        yield put({
            type: JOURNAL_ENTRY_FORMATS_SET_PAGINATION,
            pagination: { current: page, pageSize: per, total }
        })

        yield put({
            type: JOURNAL_ENTRY_FORMATS_FETCH_SUCCESS,
            ...normalizeData
        })
    })
}

export function *fetchJournalEntryFormat () {
    yield takeEvery(JOURNAL_ENTRY_FORMAT_FETCH_REQUEST, function *({ payload }) {
        yield put({ type: JOURNAL_ENTRY_FORMAT_FETCH })

        const { id } = payload

        const path = `/journal_entry_formats/${id}`
        const data = yield call(apiFetch, path)
        const formattedData = deserialize(data)
        const normalizeData = normalize(formattedData, journalEntryFormatSchema)

        yield put({
            type: JOURNAL_ENTRY_FORMAT_FETCH_SUCCESS,
            ...normalizeData
        })
    })
}

export function *saveJournalEntryFormat () {
    yield takeLatest(JOURNAL_ENTRY_FORMAT_SAVE_REQUEST, function *({ payload }) {
        yield put({ type: JOURNAL_ENTRY_FORMAT_SAVING, saving: true })

        const { id, params, onSuccess, onError } = payload

        const basePath = '/journal_entry_formats'
        const path = id ? `${basePath}/${id}` : basePath
        const method = id ? 'PATCH' : 'POST'


        try {
            const data = yield call(apiPostForm, path, method, { journal_entry_format: params })
            if ('error' in data) {
                yield put({
                    type: JOURNAL_ENTRY_FORMAT_SET_FORM_ERRORS,
                    formErrors: data.error_description
                })
            } else {
                const formattedData = deserialize(data)
                const normalizeData = normalize(formattedData, journalEntryFormatSchema)

                yield put({
                    type: JOURNAL_ENTRY_FORMAT_SAVE_SUCCESS,
                    ...normalizeData
                })

                yield put({
                    type: JOURNAL_ENTRY_FORMAT_SET_FORM_ERRORS,
                    formErrors: {}
                })

                onSuccess()
            }
        } catch (error) {
            onError(error)
        } finally {
            yield put({ type: JOURNAL_ENTRY_FORMAT_SAVING, saving: false })
        }
    })
}

export function *deleteJournalEntryFormat () {
    yield takeLatest(JOURNAL_ENTRY_FORMAT_DELETE_REQUEST, function *({ payload }) {
        yield put({ type: JOURNAL_ENTRY_FORMAT_DELETE })

        const { id, onSuccess } = payload
        const path = `/journal_entry_formats/${id}`
        const data = yield call(apiFetch, path, 'DELETE')
        const formattedData = deserialize(data)
        const normalizeData = normalize(formattedData, journalEntryFormatSchema)

        yield put({
            type: JOURNAL_ENTRY_FORMAT_DELETE_SUCCESS,
            ...normalizeData
        })

        onSuccess()
    })
}

export default function *rootSaga () {
    yield all([
        fork(fetchJournalEntryFormats),
        fork(saveJournalEntryFormat),
        fork(deleteJournalEntryFormat),
        fork(fetchJournalEntryFormat)
    ])
}
